<template>

	<page>
		<title-view>{{ $t("attributes.screen") }} {{ $t("attributes.projects") }}
		</title-view>
		<row>
			<c-col>
				<projects-table :hide-search="{is_not_clone:1,type: 2,is_open:0}" @add="addOrder" @close="closeProject" @edit="onEdit" @import="openImportModal"/>
			</c-col>
		</row>

		<full-screen-dialog v-model="openModal">
			<span slot="header">{{ $t("pages.orderView.constrationSiteForm") }}</span>
			<construction-form v-if="openModal" :project="project" :disabled-project="true" @save="onSave" :current-measurement="null"/>
		</full-screen-dialog>
		<project-import-dialog :disabledProject="true" v-if="importModal" v-model="importModal"/>
		<popup-dialog v-model="editModal">
			<project-form v-if="editModal" :project="project" @save="editSave"/>
		</popup-dialog>
	</page>


</template>

<script>
	import ProjectsTable from "src/view/projects/ProjectsTable";
	import ConstructionForm from "src/view/orders/ConstructionForm";
	import {types as ProjectType} from "src/store/modules/Project.module";
	import FullScreenDialog from "src/scaffoldings/FullScreenDialog";
	import ProjectImportDialog from "src/view/import/ProjectImportDialog";
	import ProjectForm from "src/view/projects/ProjectForm";

	export default {
		name: "projects-view",
		components: {ProjectForm, ProjectImportDialog, FullScreenDialog, ConstructionForm, ProjectsTable},
		data() {
			return {
				openModal: false,
				loadProject: false,
				importModal: false,
				editModal: false
			};
		},
		computed:{
			project(){
				return this.$store.state.ProjectModule.project;
			}
		},
		methods: {
			closeProject(project) {
				project.closed_at = moment().format("YYYY/MM/DD HH:mm");
				this.$store.dispatch(ProjectType.UPDATE, project);
				this.$store.commit(ProjectType.GET);
			},
			openImportModal(project) {
				this.$store.commit(ProjectType.GET, project);
				this.importModal = true;
			},
			async addOrder(project) {
				// let clone = Object.assign({}, project, {id: null, orders: [], clone_id: project.id});
				this.$store.commit(ProjectType.GET, project);
				this.openModal = true;
			},
			onSave() {
				this.openModal = false;
			},
			onEdit(project) {
				this.$store.commit(ProjectType.GET, project);
				this.editModal = true;
			},
			editSave(){
				this.editModal = false;
			}
		}
	};
</script>

<style scoped>

</style>
